<template>
  <div>
    <div ref="classTip"
         class="seletct-bar"
         :class="selectedBarTitleFixed == true ? 'selectedBarTitleFixed' :''"
         :style="selectedBarTitleFixed == true && !isMobileStyle ? 'width:'+tipWidth+'px' :''">
      <div class="select flex-center hand"
           :class="activeType === index ? 'active' : ''"
           @click="activeType = index"
           v-for="(item, index) in navList"
           :key="index">
        {{ item.navName }}
      </div>
    </div>
    <!-- 课程详情 -->
    <div class="detail-container"
         v-if="activeType === 0">
      <div class="desp"
           v-html="cardInfo.desp"></div>
    </div>
    <!-- 课程安排 -->
    <div class="plan-container"
         v-else-if="activeType === 1 && !isMobileStyle">
      <div class="plan-detail"
           v-for="(item, index) in subclassDetail"
           v-bind:key="index">
        <div class="new_info">
          <slot v-if="classState === 'offline'">
            <div class="class-name newclass_name"
                 v-if="classState === 'offline'">
              {{ item.name }}
            </div>
            <div class="class-time newclass_time"
                 v-if="classState === 'offline'">
              <div style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                ">
                {{ item.time }}
                {{ item.teachername }}
                <el-button type="primary"
                           class="class-facestate"
                           :disabled="item.btnState"
                           v-if="offlineListbtnState&&item.text"
                           @click="toOfflineLive(item.subclassId)">{{ item.text }}</el-button>
              </div>
            </div>
          </slot>
          <slot v-else-if="classState === 'live'">
            <div class="class_list_style">
              <div style="display: flex; width: 80%; flex-wrap: wrap">
                <h4 class="newclass_subject">{{ item.subject }}</h4>
                <p class="subtitle">{{ item.desp }}</p>
                <div class="newclass_state"
                     :class="
                    item.statusName === '未开始'
                      ? 'state_styleno'
                      : item.statusName === '已结束'
                      ? 'state_styleyes'
                      : 'state_stylenow'
                  ">
                  {{ item.statusName }}
                </div>
              </div>
              <slot v-if="
                  item.action !== '进入直播' &&
                  item.action !== '看回放' &&
                  item.action !== '已预约' &&
                  item.action !== '已过期'
                "
                    style="color: rgba(44, 45, 46, 0.8)">
                <slot v-if="classData.groupBuy">原价 &yen;{{ Number((item.price / 100).toFixed(2)) }} 团购
                  &yen;{{ Number((item.group_price / 100).toFixed(2)) }}</slot>
                <slot v-else>&yen;{{ Number((item.price / 100).toFixed(2)) }}</slot>
              </slot>
            </div>
            <div class="newclass_time disflex"
                 style="justify-content: space-between">
              <div class="class_list_date">
                {{ item.date }} {{ item.week }}
                <span>·</span>
                {{ item.teachers }}
              </div>
              <div class="disflex">
                <div v-if="item.overdueDate && !classData.inShareState"
                     class="attribute col-md-5 col-sm-12 col-xs-12 no-padding">
                  <p class="overduedate">观看有效期至{{ item.overdueDate }}</p>
                </div>
                <div class="attribute action">
                  <a v-if="
                      (item.price === 0 || item.purchased) &&
                      item.action !== '立报此课程'
                    "
                     @click.prevent="tolive(item.href, item.actionBtn)"
                     :class="'btn' + item.actionBtn"
                     :data-status="item.status"
                     :data-id="item.subclass_id"
                     :data-classId="item.class_id"
                     :data-price="Number((item.price / 100).toFixed(2))">{{ item.action }}</a>
                </div>
              </div>
            </div>
          </slot>
        </div>
      </div>
    </div>
    <!-- 课程安排phone -->
    <div v-else-if="activeType === 1 && isMobileStyle"
         class="class-plan-detail"
         v-for="(item, index) in subclassDetail"
         :key="index"
         :style="classState === 'offline' ? 'height:59px' : 'height:126px;'">
      <slot v-if="classState === 'offline'">
        <div class="class-name newclass_name"
             v-if="classState === 'offline'">
          {{ item.name }}
        </div>
        <div class="class-time newclass_time"
             v-if="classState === 'offline'">
          <div>
            {{ item.time }}
            {{ item.teachername }}
          </div>
          <el-button type="primary"
                     class="class-facestate"
                     :disabled="item.btnState"
                     v-if="offlineListbtnState&&item.text"
                     @click="toOfflineLive(item.subclassId)"
                     style="right: -240px; top: -31px; position: relative">{{ item.text }}</el-button>
        </div>
      </slot>
      <slot v-else-if="classState === 'live'">
        <div style="display: flex">
          <div class="newclass_subject">{{ item.subject }}</div>
          <div class="statusName"
               :class="
              item.statusName === '未开始'
                ? 'statusNameyes'
                : item.statusName === '已结束'
                ? 'statusNameno'
                : 'statusNamenow'
            ">
            {{ item.statusName }}
          </div>
        </div>
        <div class="subtitle">{{ item.desp }}</div>
        <div class="newclass_namelive"
             style="justify-content: space-between">
          <div class="newclass_time">
            {{ item.date }} {{ item.week }}
            <span>·</span>
            {{ item.teachers }}
          </div>
          <div class="attribute subclass-price pc_price">
            <slot v-if="
                item.action !== '进入直播' &&
                item.action !== '看回放' &&
                item.action !== '已预约' &&
                item.action !== '已过期'
              ">
              <slot v-if="classData.groupBuy">原价 &yen;{{ Number((item.price / 100).toFixed(2)) }} 团购
                &yen;{{ Number((item.group_price / 100).toFixed(2)) }}</slot>
              <slot v-else>&yen;{{ Number((item.price / 100).toFixed(2)) }}</slot>
            </slot>
          </div>
          <div class="attribute action"
               v-if="
              (item.price === 0 || item.purchased) &&
              item.action !== '立报此课程'
            ">
            <a :href="item.href"
               :class="'btn' + item.actionBtn"
               :data-status="item.status"
               :data-id="item.subclass_id"
               :data-classId="item.class_id"
               :data-price="Number((item.price / 100).toFixed(2))"
                @click.prevent="tolive(item.href, item.actionBtn)"
               >{{ item.action }}</a>
          </div>
        </div>
        <div v-if="item.overdueDate && !classData.inShareState"
             class="newdate"
             style="font-size: 12px; color: rgba(44, 45, 46, 0.24)">
          <p>观看有效期至{{ item.overdueDate }}</p>
        </div>
      </slot>
    </div>
    <!-- 常见问题 -->
    <div v-else
         style="padding: 40px">
      <Qa :type="qaType"></Qa>
    </div>
  </div>
</template>
<script>
import Qa from '@/components/Qa'
export default {
  props: {
    subclassDetail: Array,
    classState: String,
    classData: Object,
    cardInfo: Object,
    offlineListbtnState: Boolean,
    selectedBarTitleFixed: Boolean,
    tipWidth: Number,
    belong: String
  },
  data () {
    return {
      activeType: 0,
      navList: [
        { navName: '课程详情' },
        { navName: '课程章节' },
        { navName: '常见问题' }
      ]
    }
  },
  components: {
    Qa
  },
  computed: {
    // 常见问题
    qaType () {
      return this.$route.params.classType
    },
    isMobileStyle () {
      return document.body.clientWidth < 768
    }
  },
  methods: {
    toOfflineLive (e) {
      this.$router.push({ name: 'offline-live', params: { classId: this.$route.params.classId, subId: e } })
    },
    // 去直播间
    tolive (href, q) {
      if (q.indexOf('disabled') > -1 || q.indexOf('overdue') > -1) {
        return false
      } else {
        const arr = href.split('/')
        if (arr.length === 4) {
          // const livehref = 'live'
          if (this.belong === '质心灵动量') {
            this.$router.push({
              name: 'live',
              params: { classId: arr[2], subId: arr[3], action: 'live' }
            })
          } else if (this.belong === '质心官网' || this.belong === '') {
            const webarr = href.replace('/', '#')
            window.open(
              process.env.VUE_APP_ZHIXIN_URL + webarr + '/live',
              '_blank'
            )
          }
        } else {
          if (this.belong === '质心灵动量') {
            this.$router.push({
              name: 'live',
              params: { classId: arr[2], subId: arr[3], action: arr[4] }
            })
          } else if (this.belong === '质心官网' || this.belong === '') {
            const webarr = href.replace('/', '#')
            window.open(process.env.VUE_APP_ZHIXIN_URL + webarr, '_blank')
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_base.scss";
.seletct-bar {
  height: 46px;
  background: #f8f9f9;
  display: flex;
  align-items: center;
  .active {
    height: 100%;
    background-color: white;
    border-top: 3px #38d3cd solid;
  }
  .select {
    width: 136px;
    height: 100%;
    font-size: 14px;
    font-weight: 400;
    color: #2c2d2e;
  }
}
.detail-container {
  width: 100%;
  overflow: hidden;
  min-height: 300px;
  background: #fff;
  .desp {
    background: #fff;
    padding: 20px;
    img {
      max-width: 100%;
    }
  }
}
.plan-container {
  margin: 35px 40px 0 40px;
  .plan-detail {
    min-height: 36px;
    flex-direction: column;
    justify-content: center;
    margin-top: 23px;
    border-bottom: 1px solid rgba(51, 51, 51, 0.06);
    // 课程列表样式
    .new_info {
      .newclass_namelive {
        display: flex;
        justify-content: space-between;
        .class_list_date {
          font-size: 14px;
          font-weight: 400;
          color: rgba($gray-base, 0.8);
          line-height: 14px;
        }
      }
      .overduedate {
        margin-right: 17px;
        font-size: 12px;
        color: rgba($gray-base, 0.24);
      }
      .class_list_style {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .newclass_state {
          border-radius: 4px;
          border: 1px solid;
          height: 12px;
          font-size: 12px;
          line-height: 12px;
          padding: 2px;
          box-sizing: unset;
        }
        //状态按钮样式  未开始和已结束
        .state_styleno {
          background: rgba(0, 199, 191, 0.1);
          color: rgba(0, 199, 191, 1);
        }
        .state_styleyes {
          background: rgba(51, 51, 51, 0.03);
          color: rgba(51, 51, 51, 0.24);
        }
        .state_stylenow {
          background: rgba(254, 200, 94, 0.1);
          color: rgba(254, 200, 94, 1);
        }
        .newclass_subject {
          max-width: 100%;
          height: 21px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: 9px;
          font-weight: 600;
          font-size: 16px;
          margin-right: 16px;
        }
        .subtitle {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          max-width: 70%;
          overflow: hidden;
          font-size: 14px;
          color: rgba(51, 51, 51, 0.5);
          margin-bottom: 9px;
          padding-right: 6px;
        }
      }
      .newclass_time {
        margin: 24px 0;
        color: rgba($gray-base, 0.8);
      }
      .newclass_name {
        font-size: 16px;
        font-weight: 500;
        color: $gray-base;
        line-height: 16px;
      }
    }
    .info {
      display: flex;
      height: 100%;
      .class-name {
        font-size: 14px;
        font-weight: 500;
        color: rgba(44, 45, 46, 1);
        font-size: 16px;
        margin-bottom: 18px;
      }
      .newclass_name {
        display: flex;
        justify-content: space-between;
        .newclass_namelive {
          display: flex;
          div:nth-child(2) {
            font-size: 14px;
            color: rgba(44, 45, 46, 0.4);
            line-height: 24px;
            margin: 0px 12px 0px 8px;
          }
          div:nth-child(3) {
            width: 44px;
            height: 20px;
            font-size: 12px;
            font-weight: 500;
            color: rgba(51, 51, 51, 0.24);
            line-height: 20px;
            background: rgba(51, 51, 51, 0.03);
            border-radius: 4px;
            text-align: center;
          }
          div:nth-child(4) {
            width: 44px;
            height: 20px;
            box-sizing: border-box;
            border-radius: 4px;
            border: 1px solid #ffa000;
            font-size: 12px;
            color: #ffa000;
            text-align: center;
            margin-left: 8px;
          }
        }
      }
      .class-time {
        margin-left: 32px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 0.8);
        display: flex;
        justify-content: space-between;
        align-items: center;
        .class-facestate {
          width: 74px;
          height: 30px;
          border-radius: 4px;
          text-align: center;
        }
        .class_livetime {
          font-size: 12px;
          color: rgba(44, 45, 46, 0.24);
          margin-right: 17px;
        }
      }
      .newclass_time {
        margin: 0px;
        color: rgba($gray-base, 0.8);
      }
    }
    .action {
      .btnbtn-success {
        color: white;
        height: 30px;
        background: rgba(0, 199, 191, 1);
        border-radius: 4px;
        padding: 6px;
        cursor: pointer;
      }
      .disabled {
        background: rgba(51, 51, 51, 0.16);
      }
      .overdue {
        background: rgba(51, 51, 51, 0.16);
      }
    }
  }
}
.class-plan-detail {
  height: 126px;
  .newclass_subject {
    height: 23px;
    font-size: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    // width: 50%;
    font-weight: 600;
    color: #333;
    max-width: 85%;
  }
  .statusName {
    border-radius: 4px;
    border: 1px solid;
    height: 12px;
    font-size: 12px;
    line-height: 12px;
    padding: 2px;
    box-sizing: unset;
  }
  .statusNameno {
    background: rgba(0, 199, 191, 0.1);
    color: rgba(0, 199, 191, 1);
  }
  .statusNameyes {
    background: rgba(51, 51, 51, 0.03);
    color: rgba(51, 51, 51, 0.24);
  }
  .statusNamenow {
    background: rgba(254, 200, 94, 0.1);
    color: rgba(254, 200, 94, 1);
  }
  .newclass_namelive {
    display: flex;
  }
  .subtitle {
    height: 23px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }
  .newclass_name {
    font-size: 16px;
    font-weight: 500;
    color: $gray-base;
    margin-bottom: 8px;
  }
  .newclass_time {
    font-size: 13px;
    font-weight: 400;
    color: $gray-base;
    line-height: 14px;
  }
}
//平板适配

@media (min-width: 768px) and (max-width: 1023px) {
  #class-detail-container {
    .pc-web {
      .left {
        width: 71.2%;
        .content {
          width: unset;
          max-width: 457px;
          .selectedBarTitleFixed {
            max-width: 457px;
          }
          .plan-container {
            .plan-detail {
              .line {
                width: unset;
              }
              .new_info {
                .newclass_time {
                  flex-direction: column;
                  .disflex {
                    margin-top: 11px;
                  }
                }
                .newclass_namelive {
                  flex-direction: column;
                  .class_list_date {
                    margin-bottom: 8px;
                  }
                }
                .class_list_style .subtitle {
                  max-width: 75%;
                }
              }
            }
          }
        }
        .title {
          width: unset;
        }
        #class_teacherlist {
          width: unset;
        }
        .web_subTitle {
          width: unset;
        }
      }
      .right {
        width: 286px;
        .row {
          .status {
            width: 74px !important;
          }
        }
      }
    }
  }
}
@media (max-width: 320px) {
  .iphone_process {
    left: 209px;
  }
  #class-detail-container {
    .newclass_namelive {
      flex-direction: column;
      .action {
        margin: 8px 0px;
      }
    }
  }
}
// 手机端样式处理
@media (min-width: 320px) and (max-width: 767px) {
  #class-detail-container {
    .phone {
      .class-plan-detail {
        display: flex;
        margin: 17px 16px 0 16px;
        border-bottom: 1px rgba(51, 51, 51, 0.06) solid;
        height: 96px;
        flex-direction: column;
        .title {
          font-size: 16px;
          font-weight: 400;
          color: rgba(30, 30, 30, 1);
        }
        .time {
          font-size: 13px;
          font-weight: 400;
          color: rgba(44, 45, 46, 1);
        }
        .subtitle {
          font-size: 13px;
          font-weight: 400;
          color: rgba(44, 45, 46, 0.4);
          margin: 8px 0px 12px 0px;
        }
        .newclass_namelive {
          .action {
            .btnbtn-success {
              color: white;
              height: 30px;
              background: #00c7bf;
              border-radius: 4px;
              padding: 6px;
              cursor: pointer;
            }
            .disabled {
              background: rgba(51, 51, 51, 0.16);
            }
            .overdue {
              background: rgba(51, 51, 51, 0.16);
            }
          }
        }
      }
    }
  }
}
</style>
